import { ApiQuizAdapter } from '@fmnts/api';
import { Adapter } from '@fmnts/core';
import { IApiNextQuiz, IApiNextQuizStatus } from '../api-model/quiz.api';
import { NextQuiz, NextQuizStatus } from '../model/quiz';
import { QuizPageAdapter } from './quiz-page.adapter';

export class ApiNextQuizAdapter implements Adapter<NextQuiz> {
  private readonly quizAdapter = new ApiQuizAdapter();
  private readonly quizPageAdapter = new QuizPageAdapter();
  private readonly quizStatusAdapter = new ApiNextQuizStatusAdapter();

  public adapt(apiDto: IApiNextQuiz): NextQuiz {
    const quiz = this.quizAdapter.adapt(apiDto.quiz);

    // The quiz pages must be adapted separatly
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    quiz.steps = quiz.steps.map((page) => this.quizPageAdapter.adapt(page));

    return new NextQuiz({
      quiz,
      status: this.quizStatusAdapter.adapt(apiDto.status),
    });
  }
}

export class ApiNextQuizStatusAdapter implements Adapter<NextQuizStatus> {
  public adapt(apiDto: IApiNextQuizStatus): NextQuizStatus {
    return {
      failedAttempts: apiDto.failed_attempts,
      successfulAttempts: apiDto.successful_attempts,
      isExpired: apiDto.is_expired,
    };
  }
}
